import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: "#71878f",
    },
    secondary: {
      main: "#9a9a9a",
    },
    disabled: "#e2e2e2"
  },
});